<template>


    <div>
        <div>
            <form name="reqKMCISForm" method="post" action="#">
                <input type="hidden" name="tr_cert"     v-model = "tr_cert" >
                <input type="hidden" name="tr_url"      v-model="tr_url" >
            </form>
        </div>

        <v-dialog/>
    </div>
</template>

<script>
    import { getAfterActivationDetailEncrypt } from '@/api/common'

    export default {
        name: "afterActivationAuthPopup",

        data() {
            return {
                tr_cert:'',
                tr_url:'',//TODO 나중에 tr_url 변경

                currentURL:'',

                reqInfo:'',
                returnURL:'',


            }
        },

        created() {
            this.getInfo();
        },

        methods: {
            getInfo() {
                let serverName = location.hostname
                getAfterActivationDetailEncrypt(serverName).then(res => {
                    this.tr_cert = res.data.tr_cert
                    this.tr_url = res.data.tr_url
                    this.$nextTick(()=>{
                        document.reqKMCISForm.action = 'https://www.kmcert.com/kmcis/web/kmcisReq.jsp';
                        document.reqKMCISForm.submit();
                    })
                }).catch(error => {
                    alert(error.message)
                })
            },
        },
    }
</script>

<style scoped>

</style>